import {useState} from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import axios from "axios";
import {useNavigate} from "react-router-dom";

function FormExample() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [showMessage, setShowMessage] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    axios
      .post("https://wms-sf6o.onrender.com/admin", {email, password})
      .then((res) => {
        console.log(res, 21);
        if (res.data.user !== "No Record") {
          navigate("/admin-panel");
          localStorage.setItem("admin", "true");
        } else {
          setShowMessage(true);
          console.log("Invalid Credentials!");
        }
      })
      .then((err) => console.log(err));
  };

  return (
    <div
      className="container"
      style={{
        display: "flex",
        margin: "auto",
        justifyContent: "space-around",
        fontFamily: "Poppins",
      }}>
      <Form
        onSubmit={handleSubmit}
        style={{
          border: "2px solid #F8EDED",
          padding: "5px 20px 20px 20px",
          borderRadius: "10px",
          boxShadow: "5px 5px 20px #F8EDED, -2px -2px 0px #F8EDED",
        }}>
        <p
          className={` ${
            showMessage ? "" : "d-none"
          } message text-danger text-center`}>
          Invalid credentials!
        </p>
        <div
          className="form-wrap"
          style={{
            overflow: "hidden",
          }}>
          <h3
            className="animate__animated animate__bounceInLeft"
            style={{
              color: "#ffffff",
              textAlign: "center",
              marginBottom: "-10px",
            }}>
            Admin Panel
          </h3>
          <hr
            style={{
              borderTop: "5px dotted #F8EDED",
              opacity: "0.6",
            }}
          />
        </div>

        <Row className="mb-3">
          <Form.Group as={Col} md="18" controlId="validationCustom01">
            <Form.Control
              required
              type="text"
              placeholder="Admin Id"
              style={{
                border: "2px solid #F8EDED",
                borderRadius: "30px",
              }}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>
        </Row>
        <Row className="mb-3">
          <Form.Group as={Col} md="18" controlId="validationCustom01">
            <Form.Control
              required
              type="password"
              placeholder="Enter Password"
              style={{
                border: "2px solid #F8EDED",
                borderRadius: "30px",
              }}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>
        </Row>

        <Button
          type="submit"
          style={{
            backgroundColor: "#ffffff",
            border: "none",
            display: "flex",
            margin: "auto",
            borderRadius: "30px",
            fontWeight: "bold",
            color:"#800000"
          }}>
          Login
        </Button>
      </Form>
    </div>
  );
}

export default FormExample;
